import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { SupplierComponent } from '../supplier/supplier.component';
import { SupplierInvoiceDetailComponent } from '../supplier-invoice-detail/supplier-invoice-detail.component';
import { SupplierInvoiceReportComponent } from '../supplier-invoice-report/supplier-invoice-report.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-supplier-list',
  templateUrl: './supplier-list.component.html',
  styleUrls: ['./supplier-list.component.css']
})
export class SupplierListComponent implements OnInit {

  public menu_item_id = '8';
  public add_auth;
  public edit_auth;
  public del_auth;
  
  private dp = [];
  displayedColumns = ['acct_number', 'supplier_name', 'supplier_name_en', 'city_name', 'mobile',
    'purchases_invoice', 'purchases_detail', 'invoice', 'show_file', 'edit', 'del'];
  displayedColumns2 = ['acct_number', 'supplier_name', 'supplier_name_en', 'city_name', 'mobile'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<SupplierComponent>;
  detailDialogRef: MatDialogRef<SupplierInvoiceDetailComponent>;
  reportDialogRef: MatDialogRef<SupplierInvoiceReportComponent>;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': 'supplier', 'supplier_name': '', 'acct_number': '',
    'mobile': '', 'phone1': '', 'tax_no': '', 'branch_id': '-1', 'title': 'قائمة الموردين'
  };

  branchList = [];

  Supplier_List; Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Supplier_List').subscribe((res: string) => {
      this.Supplier_List = res;
    });
    this.model['title'] = this.Supplier_List;

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });
  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
        this.branchList.push({ 'branch_id': '0', 'branch_name': 'مشترك لجميع الفروع', 
            'branch_name_en': 'Common to all branches' });
            
        this.branchList.unshift({ 'branch_id': '-1', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });
  }

  search() {

    let condition = "";

    if (this.model['supplier_name'] != '')
      condition = " AND (`supplier`.`supplier_name` LIKE '%" + this.model['supplier_name'] +
        "%' OR `supplier`.`supplier_name_en` LIKE '%" + this.model['supplier_name'] + "%')";

    if (this.model['acct_number'] != '')
      condition += " AND `supplier`.`acct_number` LIKE '%" + this.model['acct_number'] + "%'";

    if (this.model['mobile'] != '')
      condition += " AND `supplier`.`mobile` LIKE '%" + this.model['mobile'] + "%'";

    if (this.model['phone1'] != '')
      condition += " AND (`supplier`.`phone1` LIKE '%" + this.model['phone1'] + "%' OR `supplier`.`phone2` LIKE '%" + this.model['phone1'] + "%')";

    if (this.model['tax_no'] != '')
      condition += " AND `supplier`.`tax_no` LIKE '%" + this.model['tax_no'] + "%'";

    if (this.model['branch_id'] != '-1')
      condition += " AND `supplier`.`branch_id` = '" + this.model['branch_id'] + "'";

    else if (this.model['branch_id'] == '-1') {
      let index = 1;
      let list_length = this.branchList.length;

      condition += " AND `supplier`.`branch_id` IN (";
      this.branchList.forEach(element => {
        if (element.branch_id != '-1') {
          if (index < list_length)
            condition += " '" + element.branch_id + "',";
          else if (index == list_length)
            condition += " '" + element.branch_id + "'";
        }
        index++;
      });
      condition += ")";
    }

    // let query = "SELECT `supplier`.*, `city`.`city_name`, `country`.`country_id` FROM `supplier`, `city`, `country` WHERE `supplier`.`city_id` = `city`.`city_id`"
    //   + condition + " AND `city`.`country_id` = `country`.`country_id` AND `supplier`.`status` = '1'";

    let query = "SELECT `supplier`.*, " +
      "(CASE WHEN `supplier`.`city_id` != '0' THEN (SELECT `city_name` FROM `city` WHERE `city_id` = `supplier`.`city_id`) ELSE '' END) AS `city_name`, " +
      "(CASE WHEN `supplier`.`city_id` != '0' THEN (SELECT `country_id` FROM `city` WHERE `city_id` = `supplier`.`city_id`) ELSE '0' END) AS `country_id` " +
      "FROM `supplier` WHERE `supplier`.`status` = '1'" + condition;

    // console.log(query);
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
    // this.model = { 'table_name': 'supplier', 'supplier_name': '', 'acct_number': '', 'mobile': '', 'phone1': '', 'tax_no': '' };
  }

  newSupplierEntry() {
    this.addDialogRef = this.dialog.open(SupplierComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        // if (result != null && result['op_type'] == 'success')
        //   this.search();
      });
  }

  invoice_detail(row, type) {
    let dialog_data = {
      'supplier_id': row.supplier_id,
      'supplier_name': row.supplier_name,
      'supplier_name_en': row.supplier_name_en,
      'acct_number': row.acct_number,
      'mobile': row.mobile,
      'type': type
    };

    this.detailDialogRef = this.dialog.open(SupplierInvoiceDetailComponent, {
      hasBackdrop: false,
      data: dialog_data
    });

  }

  invoice_report(row) {
    let dialog_data = {
      'supplier_id': row.supplier_id,
      'supplier_name': row.supplier_name,
      'supplier_name_en': row.supplier_name_en,
      'acct_number': row.acct_number,
      'mobile': row.mobile
    };

    this.reportDialogRef = this.dialog.open(SupplierInvoiceReportComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
  }

  editSupplier(row) {
    let dialog_data = [{
      'table_name': 'supplier', 'supplier_id': row.supplier_id,
      'supplier_name': row.supplier_name,
      'supplier_name_en': row.supplier_name_en,
      'acct_number': row.acct_number,
      'supplier_category_id': row.supplier_category_id,
      'city_id': row.city_id,
      'tax_no': row.tax_no,
      'address': row.address,
      'mobile': row.mobile,
      'phone1': row.phone1,
      'phone2': row.phone2,
      'fax': row.fax,
      'email': row.email,
      'represent1': row.represent1,
      'represent1_mobile': row.represent1_mobile,
      'represent2': row.represent2,
      'represent2_mobile': row.represent2_mobile,
      'supplier_cr': row.supplier_cr,
      'comment': row.comment,
      'key': 'supplier_id',
      'flag': 'update',
      'is_account': row.is_account,
      'branch_id': row.branch_id
    },
    { 'country_id': row.country_id }];

    this.addDialogRef = this.dialog.open(SupplierComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  delSupplier(row) {
    if (confirm(this.Del_Msg)) {
      
      let values = [{ 'table_name': this.model['table_name'], 'supplier_id': row.supplier_id },
        { 'table_name': 'sub_acct', 'acct_number': row.acct_number }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  print() {
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.Supplier_List + '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('supplier_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
